import React, {useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';

import { auth } from '../../firebase';

import ShoppingCart from '../Cart/ShoppingCart.js'
import VerifyEmail from '../Register/confirmEmailPopup.js';
import { ENDPOINT_PATH } from '../../config';

// Images
import logoImage from '../../images/Logo-Base-basic.png';

// Icons
import { FaBars } from 'react-icons/fa';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';


const Navbar = (props) => {
    const navigate = useNavigate();
    const [useShoppingCart, setUseShoppingCart] = useState(false);
    const [useVerifyReminder, setVerifyReminder] = useState(false);
    const [user, setUser] = useState(null);
    const isLoggedIn = user !== null;
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showDiv, setShowDiv] = useState(false);
    const [userUid, setUserUid] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isArtist, setIsArtist] = useState(false);  // NEW: Artist user detection
    const [isEmployee, setIsEmployee] = useState(false);  // NEW: Employee user detection
    const [artistDocId, setArtistDocId] = useState(null);  // Cache artistDocId to avoid repeated fetches
 

    // ------------------------------------- UseEffects -------------------------------------
    // UseEffect to get user
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUser(user);
            setUserUid(user ? user.uid : null);
        });

        const storedUser = JSON.parse(localStorage.getItem('user'));
        console.log("storedUser:", storedUser);
        
        setUser(storedUser);
        setUserUid(storedUser ? storedUser.uid : null);

        const getAccountType = () => {
            fetch(ENDPOINT_PATH + `/api/get-account-type?user=` + encodeURIComponent(storedUser.uid))
            .then(response => response.json())
            .then(data => { 
                const userType = data.toLowerCase();  // Normalize to lowercase
                
                // Reset all user type flags
                setIsAdmin(false);
                setIsArtist(false);
                setIsEmployee(false);
                
                // Set the appropriate flag based on user type
                if (userType === "admin") {
                    setIsAdmin(true);
                    console.log("User type: Admin");
                } else if (userType === "artist") {
                    setIsArtist(true);
                    console.log("User type: Artist");
                } else if (userType === "employee") {
                    setIsEmployee(true);
                    console.log("User type: Employee");
                } else {
                    console.log("User type: General");
                }
            })
            .catch(e => { console.error("Error fetching account type:", e); });
        }

        if (storedUser != null)
        {
            getAccountType();
        }

        return () => unsubscribe();
    }, []);

    // Separate useEffect to fetch artistDocId when user is detected as artist
    // This runs independently when isArtist becomes true, avoiding unnecessary re-renders
    useEffect(() => {
        if (isArtist && !artistDocId && userUid) {
            fetch(ENDPOINT_PATH + `/api/get-user-info?user=` + userUid)
                .then(response => response.json())
                .then(userData => {
                    if (userData.artistDocId) {
                        setArtistDocId(userData.artistDocId); // Cache for later use
                    }
                })
                .catch(error => {
                    console.error('Error pre-fetching artistDocId:', error);
                });
        }
    }, [isArtist, artistDocId, userUid]);


    // ------------------------------------- Helper methods -------------------------------------
    const handleLoginClick = () => {
        // Navigate to login page, passing current location for redirect after login
        navigate('/login', { state: { from: { pathname: window.location.pathname } } });
    }

    const toggleShoppingCart = () => {
        setUseShoppingCart(!useShoppingCart);
        props.toggleScrollLock();
    }

    const toggleVerifyReminder = () => {
        setVerifyReminder(!useVerifyReminder);
    }

    const useAccountSettings = () => {
        window.location.href = "/account";
    }

    const openAdminPortal = () => {
        window.location.href = "/admin-dashboard";
    }

    const openArtistPortal = async () => {
        // Use cached artistDocId if available
        if (artistDocId) {
            window.location.href = `/artists/${artistDocId}/dashboard`;
            return;
        }

        // Fetch artistDocId from user document if not cached
        try {
            const user = auth.currentUser;
            if (!user) {
                alert('Please login to access the Artist Portal');
                return;
            }

            const response = await fetch(ENDPOINT_PATH + `/api/get-user-info?user=` + user.uid);
            const userData = await response.json();
            
            if (userData.artistDocId) {
                setArtistDocId(userData.artistDocId); // Cache for future use
                window.location.href = `/artists/${userData.artistDocId}/dashboard`;
            } else {
                alert('Artist profile not linked. Please contact admin.');
            }
        } catch (error) {
            console.error('Error fetching artist information:', error);
            alert('Error accessing Artist Portal. Please try again.');
        }
    }

    const openEmployeePortal = () => {
        window.location.href = "/employee-dashboard";
    }

    const handleLogout = async (e) => {

        e.preventDefault();

        try {
            await auth.signOut();

            // Update the local state to reflect the user is logged out
            setUser(null);
            setUserUid(null);

            // Remove user from local storage
            localStorage.removeItem('user');

            console.log('Logout successful');

            // Reload page
            window.location.reload();
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    console.log('Is user logged in:', isLoggedIn, userUid);


    // ------------------------------------- Animations -------------------------------------
    // Animations for the mobile view
    const mountedStyle = {
        animation: "inAnimation 0.5s ease-in-out",
        animationFillMode: "forwards"
    };
    const unmountedStyle = {
        animation: "outAnimation 0.5s ease-out",
        animationFillMode: "forwards"
    };


    return (
        <div className="navWrapper">
            <div className={`Nav NavBarMain ${props.darkNavbar ? 'NavDark' : ''}`}>
                <div>
                    <a href = "/" className={`NavLink ${isMobileMenuOpen === true && "d-none"}`}>
                        <div className="d-flex justify-content-end">
                            <img src={logoImage} alt='logo' className="NavLogo" />
                        </div>
                            <div className="font-2 ps-2 fontLogo">mycustomframe</div>
                        </a>
                </div>
                
                {isMobileMenuOpen === false && 
                    <FaBars className="Bars" onClick={() => { 
                        setIsMobileMenuOpen(!isMobileMenuOpen); 
                        if (!showDiv) { setShowDiv(true) }
                    }}/>
                }

                <div className="NavMenu col">
                     <a href="/visualizationTool" className="NavLink">
                        <div className="NavLink">build a frame</div>
                    </a> 
                    <a href="/artist-gallery" className="NavLink">
                        <div className="NavLink">artist alley</div>
                    </a> 
                    <a href="/frame-guide" className="NavLink">
                        <div className="NavLink">frame guide</div>
                    </a> 
                </div>

                <div className="NavBtn mobileHidden">

                    {!isLoggedIn && ( <div className="button font-2 NavBtnLink NavLogButton" onClick={handleLoginClick}>log in</div> ) }
                    {useVerifyReminder && <VerifyEmail handleClose={toggleVerifyReminder} />}

                    {/* Admin Dropdown */}
                    {isLoggedIn && isAdmin && ( 
                    <Dropdown>
                        <Dropdown.Toggle className="AccountIcon-dropdown">
                            <PersonIcon className="NavBtnLink AccountIcon" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu  className="AccountIcon-dropdown-menu">
                            <Dropdown.Item onClick = {useAccountSettings}>Account Settings</Dropdown.Item>
                            <Dropdown.Item onClick = {openAdminPortal}>Admin Portal</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)}

                    {/* Artist Dropdown */}
                    {isLoggedIn && isArtist && ( 
                    <Dropdown>
                        <Dropdown.Toggle className="AccountIcon-dropdown">
                            <PersonIcon className="NavBtnLink AccountIcon" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu  className="AccountIcon-dropdown-menu">
                            <Dropdown.Item onClick = {useAccountSettings}>Account Settings</Dropdown.Item>
                            <Dropdown.Item onClick = {openArtistPortal}>Artist Portal</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)}

                    {/* Employee Dropdown */}
                    {isLoggedIn && isEmployee && ( 
                    <Dropdown>
                        <Dropdown.Toggle className="AccountIcon-dropdown">
                            <PersonIcon className="NavBtnLink AccountIcon" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu  className="AccountIcon-dropdown-menu">
                            <Dropdown.Item onClick = {useAccountSettings}>Account Settings</Dropdown.Item>
                            <Dropdown.Item onClick = {openEmployeePortal}>Employee Portal</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)}

                    {/* General User - No Dropdown */}
                    {isLoggedIn && !isAdmin && !isArtist && !isEmployee && ( <PersonIcon onClick = {useAccountSettings} className="NavBtnLink AccountIcon" /> ) }

                    <div className="NavBtnLink ShoppingCart" onClick={toggleShoppingCart}>
                        <ShoppingCartIcon/>
                    </div>

                    <ShoppingCart open={useShoppingCart} handleClose={toggleShoppingCart}/>

                    {isLoggedIn && ( <div className="ps-4 NavBtnLink" onClick={handleLogout}><LogoutIcon /> </div> ) }
                </div>
            </div>

            {isMobileMenuOpen === true &&
                <div className={`transitionDiv NavMobileBG overflow-hidden`} style={isMobileMenuOpen ? mountedStyle : unmountedStyle} >

                    {isMobileMenuOpen === true &&
                        <CloseIcon className="Close text-black" fontSize={"large"} onClick={() => {
                            setIsMobileMenuOpen(!isMobileMenuOpen)
                            if (showDiv){ setShowDiv(false) }
                        }}/>
                    }

                    {useVerifyReminder && <VerifyEmail handleClose={toggleVerifyReminder} />}


                    <div className="text-center ShoppingCart" onClick={toggleShoppingCart}>
                        <ShoppingCartIcon className="CartIconSize"/>
                    </div>

                    <ShoppingCart open={useShoppingCart} handleClose={toggleShoppingCart}/>

                    <div className="mobileWrapper">

                        <a href="/visualizationTool" className="NavLinkMobile text-center">
                            <div className="NavLinkMobile">build a frame</div>
                        </a>
                        <a href="/artist-gallery" className="NavLinkMobile text-center">
                            <div className="NavLinkMobile">artist alley</div>
                        </a>
                        <a href="/frame-guide" className="NavLinkMobile text-center">
                            <div className="NavLinkMobile">frame guide</div>
                        </a>

                        {/* Dashboard and Account links for logged-in users */}
                        {isLoggedIn && (
                            <>
                                <a href="/account" className="NavLinkMobile text-center" onClick={() => setIsMobileMenuOpen(false)}>
                                    <div className="NavLinkMobile">account settings</div>
                                </a>
                                
                                {/* Admin Portal */}
                                {isAdmin && (
                                    <a href="/admin-dashboard" className="NavLinkMobile text-center" onClick={() => setIsMobileMenuOpen(false)}>
                                        <div className="NavLinkMobile">admin portal</div>
                                    </a>
                                )}
                                
                                {/* Artist Portal */}
                                {isArtist && (
                                    <div 
                                        className="NavLinkMobile text-center" 
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            setIsMobileMenuOpen(false);
                                            await openArtistPortal();
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="NavLinkMobile">artist portal</div>
                                    </div>
                                )}
                                
                                {/* Employee Portal */}
                                {isEmployee && (
                                    <a href="/employee-dashboard" className="NavLinkMobile text-center" onClick={() => setIsMobileMenuOpen(false)}>
                                        <div className="NavLinkMobile">employee portal</div>
                                    </a>
                                )}
                            </>
                        )}

                       {/* <div className="py-5"/>
                        <div className="py-5"/>
                <div className="py-2"/> */}

                        <div className="NavBtn text-center">
                            <div className="pb-2">
                            {!isLoggedIn && ( <button className="btn font-3 NavBtnLink px-5" onClick={handleLoginClick}>login</button>) }
                            {isLoggedIn && ( <button className="btn font-3 NavBtnLink px-5" onClick={handleLogout}>logout</button> ) }
                            </div> 
                        </div>
                    </div>
                </div>
            }

        </div>
    );
};

export default Navbar;
